import { Drawer as BaseDrawer } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

export const Drawer = styled(BaseDrawer)`
  position: relative;

  .ant-drawer-header {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
`;

export const RightPanel = styled.div`
  position: relative;
  padding: 0 20px 20px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: #fff;
`;

export const CloseIcon = styled(CloseOutlined)`
  position: absolute;
  top: 29px;
  right: 15px;
  z-index: 999;
`;

export const HelpRedirectWrapper = styled.div`
  position: absolute;
  top: 27px;
  right: 45px;
  z-index: 999;
`;

export const LoadingMask = styled.div`
  position: absolute;
  z-index: 99;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  background: rgb(0 0 0 / 5%);
`;

export const Container = styled.div`
  padding: 20px 0 12px;
  display: flex;
  align-items: center;
  z-index: 10;
  background-color: #fff;

  nav li {
    display: flex;
    align-items: center;
  }
`;

const clickableStyle = css`
  cursor: pointer;
  color: #0046ff;
  padding: 0 4px;

  &:hover {
    color: rgb(0 0 0 / 88%);
    background-color: rgb(0 0 0 / 6%);
  }
`;
export const Title = styled.div<{ clickable?: boolean }>`
  color: #4a4a4a;
  font-size: 20px;
  ${(props) => (props.clickable ? clickableStyle : '')}
`;
